export default __webpack_public_path__ + "static/30-9c5ff0fee7ba1b16a9d482d5ff47742a.gif";